import useGetRewardOverviewTableColumns from './useGetRewardOverviewTableColumns'

export default useGetRewardOverviewTableColumns
